import { Box, Grid, Typography } from "@material-ui/core";
import React from "react";
import { logoURL } from "./Constants";
import useStyles from "./Styles";

const HeaderView = () => {
  const classes = useStyles();

  return (
    <Grid item xs={12} container alignContent="flex-start">
      <Box m={1} mb={2}>
        <img
          src={logoURL["mrc"]}
          className={classes.applogo}
          alt="asu"
          width="auto"
          height="60px"
        />
      </Box>
      <Box m={1} ml={1} my={2}>
        <Typography variant="body1" gutterBottom>
          Shared Vision {<br />} Planning{" "}
        </Typography>
      </Box>
    </Grid>
  );
};

export default HeaderView;
